import { useEffect, useState } from "react";

import { getAsset } from "@/lib/idb";

// Resolve an image asset (TODO §3.2) to an in-memory object URL for rendering. The blob
// lives only in IndexedDB — never in Redux — so it's read on demand here and the URL is
// revoked when the assetId changes or the component unmounts, to avoid leaks.
//
// Returns `null` until the blob has loaded (or if the asset is missing / persistence is
// unavailable), so callers can render a placeholder in the meantime.
export function useImageAsset(assetId: string | undefined): string | null {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!assetId) {
      setUrl(null);
      return;
    }
    let objectUrl: string | null = null;
    let cancelled = false;

    getAsset(assetId).then((record) => {
      if (cancelled || !record) return;
      objectUrl = URL.createObjectURL(record.blob);
      setUrl(objectUrl);
    });

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
      setUrl(null);
    };
  }, [assetId]);

  return url;
}
